export default "__VITE_ASSET__BRMzly8L__"